export default __webpack_public_path__ + "static/designer-foundry-prize@2x-b94c6f175f7364008ef868d21c9da807.png";